import { render, staticRenderFns } from "./dbs.vue?vue&type=template&id=baf51258&scoped=true"
import script from "./dbs.vue?vue&type=script&lang=js"
export * from "./dbs.vue?vue&type=script&lang=js"
import style0 from "./dbs.vue?vue&type=style&index=0&id=baf51258&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf51258",
  null
  
)

export default component.exports